import { useState } from 'react'
import get from 'lodash-es/get'

import { SelectedRows } from '@/lib/core/interfaces/common.types'

export const useSelectedRows = (
  data: Array<unknown>,
  initialState: SelectedRows = {},
  key = 'bridgeId',
) => {
  const [selectedRows, setSelectedRows] = useState<SelectedRows>({ ...initialState })

  const onRowSelect = (id: string | number) => {
    const { [id]: deleted, ...rest } = selectedRows

    setSelectedRows({
      ...rest,
      ...(!deleted && { [id]: true }),
    })
  }

  const onCheckAll = (allChecked: boolean) => {
    const selected = data.reduce(
      (acc: SelectedRows, row) => ({
        ...acc,
        [get(row, key)]: true,
      }),
      {},
    )

    setSelectedRows(
      allChecked
        ? {
            ...selectedRows,
            ...selected,
          }
        : {},
    )
  }

  const resetSelectedRows = () => {
    setSelectedRows({})
  }

  return {
    onCheckAll,
    onRowSelect,
    resetSelectedRows,
    selectedRows,
  }
}
